import {
  PageTemplateContent,
  Header2,
  SkeletonLoading,
} from 'app/common/templates-next/page-template'

import { WarehouseTab } from 'app/common/types/warehouse/tabs'

import { useWarehouseTabs } from 'app/dataProviders/warehouse/tabs/hooks'

export const Underconstruction = ({
  children,
  tab,
}: {
  children?: (tabInfo: { title: string }) => React.ReactNode
  tab: WarehouseTab
}) => {
  const { data: tabs, loading } = useWarehouseTabs()
  const { title, isActive, isStub } = tabs.get(tab) || { title: '', isActive: false, isStub: false }

  if (isActive && children) {
    return children({ title })
  }

  return (
    <PageTemplateContent>
      {loading && !!children && <SkeletonLoading />}
      {(isStub || !children) && (
        <Header2 skipMargin>{'…функционал находится в процессе разработки'}</Header2>
      )}
    </PageTemplateContent>
  )
}
